module.exports = __webpack_public_path__ + "static/img/account_active.fe5e5ebf.svg";